import { createReducer, field, success } from 'redux/shelf';
import { post, get, del, put } from 'redux/shelf/api';
import session from 'lib/session';

export const actions = {
  pauseSearch: post`pause`(),
  startSearch: post`start`(),
  compileFrontendAssets:
    post`settings/${session.getMerchant}/assets/compile/frontend`(),
  refreshConfiguration: post`settings/${session.getMerchant}/search/update`(),
  refreshActiveSyncConfiguration: post`settings/active-sync`(),
  fetchApiCalls: get`analytics/reports/api_calls?t=${() =>
    new Date().getTime()}`(field('calls')),
  updateTranslations: post`/translations/export`(),
  fetchPoweredBy: get`settings/${session.getMerchant}/powered-by`(
    field('poweredBy')
  ),
  disablePoweredBy: del`settings/${session.getMerchant}/powered-by`(),
  enablePoweredBy: post`settings/${session.getMerchant}/powered-by`(),

  fetchBlockedIPs: get`settings/${session.getMerchant}/excluded-ips`(
    field('ips')
  ),
  putBlockedIPs: put`settings/${session.getMerchant}/excluded-ips`(
    field('ips')
  ),
  shopifyLiquidIntegrationOn:
    post`settings/${session.getMerchant}/enableShopifyLiquid`(field('')),
  shopifyLiquidIntegrationOff:
    post`settings/${session.getMerchant}/disableShopifyLiquid`(field('')),
};

export const reducer = createReducer(
  [actions.fetchApiCalls, actions.fetchPoweredBy, actions.fetchBlockedIPs],
  {
    [success(actions.enablePoweredBy)]: (s) => ({
      ...s,
      poweredBy: { enabled: true },
    }),
    [success(actions.disablePoweredBy)]: (s) => ({
      ...s,
      poweredBy: { enabled: false },
    }),
  }
);
